module.exports = __webpack_public_path__ + "static/SM-b358a696e1f5eb9323a73b9bfed82b10.jpg";